import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import card_dict from '../assets/card_dict.js';
import { getCardConfig } from '../utils/cardConfig';

const NfcRedirect: React.FC = () => {
    const { cardType, cardName, cardPosition } = useParams<{ cardType: string; cardName?: string; cardPosition?: string }>();
    const navigate = useNavigate();

    useEffect(() => {
        if (!cardType) {
            console.warn('No card type specified');
            navigate('/');
            return;
        }

        // 获取卡牌配置
        const config = getCardConfig(cardType);
        if (!config) {
            console.warn('Unknown card type:', cardType);
            navigate('/');
            return;
        }

        // 如果提供了完整参数，直接重定向
        if (cardName && cardPosition !== undefined) {
            navigate(`/nfc/${config.type}/read?id=${cardName}&position=${cardPosition}`);
            return;
        }

        // 随机抽牌逻辑
        const dict = (card_dict as any)[config.id] || {};
        const availableIds = Object.keys(dict);

        if (availableIds.length === 0) {
            console.warn('No cards available for type:', cardType);
            navigate('/');
            return;
        }

        // 随机选择一张牌
        const randomCardId = availableIds[Math.floor(Math.random() * availableIds.length)];

        // 如果有正逆位（塔罗牌），随机选择正逆位；否则使用默认值
        let randomPosition = '0'; // 默认正位
        if (config.hasReversed) {
            randomPosition = Math.random() < 0.5 ? '0' : '1'; // 随机正逆位
        }

        // 重定向到 NfcRead 页面
        navigate(`/nfc/${config.type}/read?id=${randomCardId}&position=${randomPosition}`);

    }, [cardType, cardName, cardPosition, navigate]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#000',
            color: '#fff',
            fontFamily: 'Urbanist, sans-serif'
        }}>
            Redirecting...
        </div>
    );
};

export default NfcRedirect;
